var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeaHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.206,
    height: 92.146,
    viewBox: "0 0 82.206 92.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.748 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.247,93.211a24.007,24.007,0,1,0-38.493,19.145,7.827,7.827,0,0,1,3.071,6.245v11.061a6.656,6.656,0,0,0,6.656,6.656H121a6.29,6.29,0,0,0,6.29-6.289V118.046a7.852,7.852,0,0,1,2.97-6.112,23.958,23.958,0,0,0,8.983-18.724Zm0,0",
    transform: "translate(-75.113 -57.289)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.746,86.328a24,24,0,0,1-2.524,35.105,7.853,7.853,0,0,0-2.97,6.112V139.16a6.656,6.656,0,0,1-6.656,6.656H166.439c-.116,0-.231,0-.345-.009a6.659,6.659,0,0,0,6.36,4.687h10.524a6.29,6.29,0,0,0,6.29-6.29V132.223a7.85,7.85,0,0,1,2.97-6.112,24.01,24.01,0,0,0-3.491-39.784Zm0,0",
    transform: "translate(-137.085 -71.466)",
    fill: "#f39320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.232,451.425a1.311,1.311,0,0,1-1.311-1.311v-9.976a1.31,1.31,0,0,1,2.621,0v9.976A1.31,1.31,0,0,1,226.232,451.425Zm0,0",
    transform: "translate(-185.785 -363.28)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.062,233.278a1.311,1.311,0,0,0-1.853,0l-4.35,4.35-4.35-4.351a1.311,1.311,0,0,0-1.853,1.853l4.894,4.894v18.467a1.31,1.31,0,1,0,2.621,0V240.025l4.893-4.894a1.311,1.311,0,0,0,0-1.853Zm0,0",
    transform: "translate(-160.411 -192.799)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.746,86.328a24,24,0,0,1-2.524,35.105,7.853,7.853,0,0,0-2.97,6.112V139.16a6.656,6.656,0,0,1-6.656,6.656H166.439c-.116,0-.231,0-.345-.009a6.659,6.659,0,0,0,6.36,4.687h10.524a6.29,6.29,0,0,0,6.29-6.29V132.223a7.85,7.85,0,0,1,2.97-6.112,24.01,24.01,0,0,0-3.491-39.784Zm0,0",
    transform: "translate(-137.085 -71.466)",
    fill: "#f39320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.463,12.3h-11.27a.517.517,0,0,1-.517-.516V.516A.517.517,0,0,1,333.193,0h11.27a.516.516,0,0,1,.516.516v11.27A.516.516,0,0,1,344.463,12.3Zm0,0",
    transform: "translate(-270.363 -4)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.276,261.362l-12-6.929a.516.516,0,0,0-.775.447v13.858a.517.517,0,0,0,.775.448l12-6.929A.516.516,0,0,0,13.276,261.362Zm0,0",
    transform: "translate(-2.248 -211.572)",
    fill: "#6a6fb1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.283,135.022a5,5,0,1,1-5-5A5,5,0,0,1,405.283,135.022Zm0,0",
    transform: "translate(-324.825 -107.635)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.543,0V12.3h4.235a.516.516,0,0,0,.516-.516V.516A.516.516,0,0,0,380.778,0Zm0,0",
    transform: "translate(-306.678 -4)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.722,283.1.5,288.422v4.1a.517.517,0,0,0,.775.447l12-6.929a.516.516,0,0,0,0-.894Zm0,0",
    transform: "translate(-2.248 -235.36)",
    fill: "#5f649f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.85,130.02a5.008,5.008,0,0,0-1.557.248,5,5,0,0,1,0,9.51,5,5,0,1,0,1.557-9.758Zm0,0",
    transform: "translate(-341.395 -107.636)",
    fill: "#f0c407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.746,86.328a24,24,0,0,1-2.524,35.105,7.853,7.853,0,0,0-2.97,6.112V139.16a6.656,6.656,0,0,1-6.656,6.656H166.439c-.116,0-.231,0-.345-.009a6.659,6.659,0,0,0,6.36,4.687h10.524a6.29,6.29,0,0,0,6.29-6.29V132.223a7.85,7.85,0,0,1,2.97-6.112,24.01,24.01,0,0,0-3.491-39.784Zm0,0",
    transform: "translate(-137.085 -71.466)",
    fill: "#f0c407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.371,364.418v9.634a6.656,6.656,0,0,0,6.656,6.656h10.524a6.29,6.29,0,0,0,6.29-6.29v-10Zm0,0",
    transform: "translate(-135.659 -301.68)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.253,364.418v4.956a6.656,6.656,0,0,1-6.656,6.656H166.439l-.345-.007a6.659,6.659,0,0,0,6.36,4.686h10.524a6.256,6.256,0,0,0,2.859-.688,6.3,6.3,0,0,0,3.431-5.6v-10h-6.015Zm0,0",
    transform: "translate(-137.085 -301.68)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.371,364.418h23.47v7.054h-23.47Zm0,0",
    transform: "translate(-135.659 -301.68)",
    fill: "#53ffe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.464,32.419l.423,1.726a8.729,8.729,0,0,0,5.262,5.935.42.42,0,0,1,0,.7,8.73,8.73,0,0,0-5.262,5.935l-.423,1.726a.349.349,0,0,1-.679,0l-.422-1.726A8.733,8.733,0,0,0,37.1,40.778a.42.42,0,0,1,0-.7,8.73,8.73,0,0,0,5.263-5.935l.422-1.726a.349.349,0,0,1,.679,0Zm0,0",
    transform: "translate(-32.144 -28.515)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16,62.842a9.487,9.487,0,0,1-4.03-3.194,9.493,9.493,0,0,1-4.03,3.194.42.42,0,0,0,0,.7,9.494,9.494,0,0,1,4.03,3.194,9.487,9.487,0,0,1,4.03-3.194A.42.42,0,0,0,45.16,62.842Zm0,0",
    transform: "translate(-32.144 -51.277)",
    fill: "#f0c407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.182,339.358l.564,2.307a11.67,11.67,0,0,0,7.035,7.933.562.562,0,0,1,0,.934,11.669,11.669,0,0,0-7.035,7.933l-.564,2.307a.467.467,0,0,1-.907,0l-.565-2.307a11.667,11.667,0,0,0-7.034-7.933.561.561,0,0,1,0-.934,11.668,11.668,0,0,0,7.034-7.933l.565-2.307A.467.467,0,0,1,348.182,339.358Zm0,0",
    transform: "translate(-280.577 -279.279)",
    fill: "#cd229a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.449,380.022a12.686,12.686,0,0,1-5.387-4.268,12.686,12.686,0,0,1-5.387,4.268.561.561,0,0,0,0,.934,12.69,12.69,0,0,1,5.387,4.268,12.681,12.681,0,0,1,5.387-4.268A.562.562,0,0,0,350.449,380.022Zm0,0",
    transform: "translate(-280.577 -309.704)",
    fill: "#ca2197"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaHover);
export default __webpack_public_path__ + "static/media/idea-hover.b2129dff4392166695277655049c750a.svg";
export { ForwardRef as ReactComponent };